module.exports = __webpack_public_path__ + "static/img/logo.e3ec2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/PMVG/logo.png
// module id = tbNJ
// module chunks = 1